import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkout-error',
  templateUrl: './checkout-error.component.html',
  styleUrls: ['./checkout-error.component.scss']
})
export class CheckoutErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
